module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"one-way-flight":"Aller Simple","two-way-flight":"Aller Retour","placeholder":"Type de voyage"},"en":{"one-way-flight":"One way","two-way-flight":"Round trip","placeholder":"Travel type"}}')
  delete Component.options._Ctor
}
